import { pushEvent } from '../../../../utilities/analytics';
import { t } from '../../../../utilities/translator';
import { DATE_TYPES } from '../../../../constants/constants';
import abTesting from '../../../../services/abTesting';
import Button from '../../../../components/button/Button';
import cn from 'classnames';

const DateTypeSwitch = ({ activeType, onClick }) => {
  const handleOptionClick = (type) => () => {
    onClick(type);
    pushEvent(`customize_when_${type}_clicked`);
  }

  return (
    <div className="move-when-type">
      {abTesting.hideDateTutorial && (
        <Button
          type="secondary"
          label={t('mainFilter.specific_dates')}
          onClick={handleOptionClick(DATE_TYPES.SPECIFIC)}
          className={cn('w-full', { active: activeType === DATE_TYPES.SPECIFIC })}
        />
      )}
      <Button
        type="secondary"
        label={t('mainFilter.whole_month')}
        onClick={handleOptionClick(DATE_TYPES.MONTH)}
        className={cn('w-full', { active: activeType === DATE_TYPES.MONTH })}
      />
      <Button
        type="secondary"
        label={t('mainFilter.date_range')}
        onClick={handleOptionClick(DATE_TYPES.RANGE)}
        className={cn('w-full', { active: activeType === DATE_TYPES.RANGE })}
      />
      {!abTesting.hideDateTutorial && (
        <Button
          type="secondary"
          label={t('mainFilter.specific_dates')}
          onClick={handleOptionClick(DATE_TYPES.SPECIFIC)}
          className={cn('w-full', { active: activeType === DATE_TYPES.SPECIFIC })}
        />
      )}
    </div>
  )
}

export default DateTypeSwitch
